var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.667 12.305V8.833M5.333 12.309V8.833M3.389 5.333l-1.065.64A.667.667 0 0 0 2 6.543v6.445a.667.667 0 0 0 1.01.572l1.939-1.164a.667.667 0 0 1 .743.039l1.908 1.43a.667.667 0 0 0 .8 0l1.908-1.43a.666.666 0 0 1 .743-.039l1.94 1.164A.667.667 0 0 0 14 12.989V6.544a.667.667 0 0 0-.324-.572l-1.065-.639M8 10.167v3.832M5.334 4a2.667 2.667 0 0 1 2.667-2.667v0A2.667 2.667 0 0 1 10.667 4v0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.334 4c0 1.204 1.329 2.49 2.11 3.142a.904.904 0 0 0 1.112 0C9.338 6.49 10.667 5.205 10.667 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 3.76a.167.167 0 1 1-.001.333A.167.167 0 0 1 8 3.759"
  })));
};
export { SvgLocation as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNWM3Nzc1YmJlYTY2Y2NmY2VlNWM1YjhmZDE4ZjhiY2Euc3ZnIjs=";